// extracted by mini-css-extract-plugin
module.exports = {"container":"Services_container__20LF0","title":"Services_title__3ajvq","services":"Services_services__2UJHq","service":"Services_service__2dF7V","text":"Services_text__tkoYS"};